export const boxStyles = () => {

    const boxContainer = {
        ".box_container": {
            display: "grid",
            gap: "16px",
            rowGap: "30px",
            gridTemplateColumns: "50% 50%",
            gridTemplateRows: "auto",
            gridTemplateAreas:
                '"production  economic"' +
                '"employment  employment"'
        },
    };

    const sections = {
        ".paper_box_1": {
            gridArea: "production",
            border: "1px solid #ACACAC",
            borderRadius: "18px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
        },
        ".paper_box_2": {
            gridArea: "economic",
            border: "1px solid #ACACAC",
            borderRadius: "18px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
        },
        ".paper_box_3": {
            gridArea: "employment",
            border: "1px solid #ACACAC",
            borderRadius: "18px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
            height: "164px", ///
        },
        ".production": {
            padding: "16px",
            display: "grid",
            rowGap: "16px",
            columnGap: "20px",
            gridTemplateColumns: "auto auto",
            gridTemplateRows: "auto",
            gridTemplateAreas:
                '"title  title"' +
                '"one  two"' +
                '"three  four"'
        },
        ".production_title": {
            gridArea: "title",
            width: "100%",
        },
        ".production_facilities": {
            gridArea: "one"
        },
        ".production_unit": {
            gridArea: "two"
        },
        ".production_consumer": {
            gridArea: "three"
        },
        ".production_spent": {
            gridArea: "four"
        },
        ".economic_impact": {
            padding: "16px",
            display: "grid",
            rowGap: "16px",
            columnGap: "20px",
            gridTemplateColumns: "auto auto",
            gridTemplateRows: "auto",
            gridTemplateAreas:
                '"title  title"' +
                '"one  two"' +
                '"three  four"'
        },
        ".economic_title": {
            gridArea: "title"
        },
        ".value_added": {
            gridArea: "one"
        },
        ".gdp_contribution": {
            gridArea: "two"
        },
        ".tax_revenue": {
            gridArea: "three"
        },
        ".value_added_per": {
            gridArea: "four"
        },

        ".employment_impact": {
            padding: "16px",
            display: "grid",
            gap: "16px",
            height: "100%",
            gridTemplateColumns: "auto auto",
            gridTemplateRows: "auto",
            gridTemplateAreas:
                '"title  title title"' +
                '"one  two three"'
        },
        ".employment_title": {
            gridArea: "title"
        },
        ".direct_job_supported": {
            gridArea: "one"
        },
        ".indirect_jobs_supported": {
            gridArea: "two"
        },
        ".direct_to_indirect_job_supported": {
            gridArea: "three"
        },

    };

    const mediaQueryStyles = {
        "@media (max-width: 768px)": {
            ".box_container": {
                gridTemplate: "",
                gridTemplateColumns: "1fr",
                textAlign: "center",
            },
            ".facilities, .unit_cases, .consumer_retail, .spent_on_domestic, .value_added, .gdp_contribution, .tax_revenue, .value_added_per, .direct_job_supported, .indirect_jobs_supported, .direct_to_indirect_job_supported":
                {
                    padding: "0 16px 16px 16px",
                },
            ".paper_box_1": {
                gridColumn: "1 / 2",
                gridRow: "1 / 6",
            },
            ".paper_box_2": {
                gridColumn: "1 / 2",
                gridRow: "6 / 11",
            },
            ".paper_box_3": {
                gridColumn: "1 / 2",
                gridRow: "11 / 15",
            },
        },
    };
    return {
        ...boxContainer,
        ...sections,
        ...mediaQueryStyles,
    };
};
